import { render, staticRenderFns } from "./Eitia.vue?vue&type=template&id=51aa2bec&scoped=true&lang=html&"
import script from "./Eitia.vue?vue&type=script&lang=js&"
export * from "./Eitia.vue?vue&type=script&lang=js&"
import style0 from "./Eitia.vue?vue&type=style&index=0&id=51aa2bec&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51aa2bec",
  null
  
)

export default component.exports